(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petro-searchbar"] && !Shopify.designMode) return;
  try {
    
  jQuery(window).ready(function(){
    function debounce(func, delay) {
      let timeoutId;
      return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    }

    function handlePetroChange(e){
      $('.index-section--hero').hide();
      $('.image-element').css('opacity',1)
      $('#search-output').empty();

      let cols = $('.petro-col-item')
      
      let searchVal = $('.petro-searchbar-input').val()

      if (searchVal == "" || !searchVal){
        $('#search-output').hide()
        $('.index-section--hero').show();
        $('.petro-col-container').css("display","flex");
        return;
      }

      searchVal = searchVal.toLowerCase().trim()

      const outputCols = [];

      cols.each((i,col) =>{
        const title = $(col).children('h3')
        const sku = $(col).children('.petro-text-label')
        
        if (!title || !sku){
          return
        }
        const titleText = $(title).text();
        const skuText = $(sku).find('p').text();
      
      
        
        if (
          titleText.toLowerCase().includes(searchVal) ||
          skuText.toLowerCase().includes(searchVal)
        ){
          outputCols.push($(col).clone())
        }
      })

      $('.petro-col-container').hide();
      $('#search-output').css("display","flex");
      $('#search-output').empty();


      if (outputCols.length == 0){
        $('#search-output').html("<h3 id='petro-empty-label'>No search results found.</h3>")
      }else {
        $.each(outputCols, function(index, element) {
          $('#search-output').append(element);
        });
      }
      
    }
    
    
    $('.petro-searchbar-input').on('keyup paste', debounce(handlePetroChange ,250))
    $('.petro-search-icon').on('click',handlePetroChange)
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-columns-petro"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function(){

    $(document).keyup(function(e) {
         if (e.key === "Escape") { // escape key maps to keycode `27`
            $('.petro-lightbox').hide();
        }
    });
    
    $(".petro-lightbox").on('click',function(){
      $('.petro-lightbox').hide();
      $('.progus-store-locator-widget-handler').show();
    });

    $(document).on('click', '.petro-popup-btn', function(e){
      $('.progus-store-locator-widget-handler').hide();
      $('.petro-lightbox').show();

      const targetLink = $(this).data('popuplink');

      $('.petro-lightbox-inner').html(`<iframe class="petro-iframe" src="${targetLink}" width="100%" height="100%" seamless="seamless" scrolling="no" frameBorder="0" allowFullScreen allow="autoplay; clipboard-read; clipboard-write"></iframe>`);


      setTimeout(() => {
      const iframe = $('.petro-iframe')[0];
      console.log(iframe)
      iframe.contentWindow.focus()
      },1000);
      // $('.petro-iframe').click()
    });

    $('.petro-lightbox-close-btn').on('click',function(){
       $('.petro-lightbox').hide();
       $('.progus-store-locator-widget-handler').show();
    })


  })

  } catch(e) { console.error(e); }
})();
})();
